import styled, {keyframes} from 'styled-components';
import image from '../../../../images/photos/02a.png';

export const PageContainer = styled.div`
  width: 100%;
  background-color: ${({backgroundColor}) => backgroundColor};
  padding: 5rem 0;
  margin-top: -12px;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 50rem;
  margin: 0 auto;

  @media (max-width: 1024px) {
    padding: 0 40px;
  }
`;

export const GalleryItem = styled.a`
  display: block;
  text-decoration: none;
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
  box-shadow: 0 0 37px 7px rgba(8, 9, 8, 0.11);

  &:hover {
    div {
      opacity: 1;
    }
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
`;

export const Darken = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.4);
  transition: 0.3s;
  opacity: 0;
`;

export const Title = styled.h4`
  font-family: LATOBLACK, sans-serif;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.67px;
  color: #ffffff;
  font-weight: 400;
  text-align: center;
`;

export const GalleryItemMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`;

export const TitleMobile = styled.h4`
  font-family: 'LATO', sans-serif;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.67px;
  color: #ffffff;
  font-weight: 500;
  text-align: center;
  margin-top: 0.4rem;
`;

export const ColorWrapper = styled.div`
  background-color: ${({bgColor}) => bgColor};
  padding: 1rem 0;
  position: relative;
`;
export const MobileColorWrapper = styled.div`
  background-color: ${({bgColor}) => bgColor};
  padding: 1rem 0 2rem;
  position: relative;
  display: none;

  @media (max-width: 1024px) {
    display: block;
  }
`;

export const GridColorWrapper = styled.div`
  background-color: ${({bgColor}) => bgColor};
  padding: 0;
  position: relative;
  display: grid;
  grid-template-columns: calc((100vw - 50rem) / 2) 2fr 3fr 1fr;
  grid-template-rows: auto;

  @media (max-width: 1340px) {
    grid-template-columns: calc((100vw - 48rem)) 2fr 3fr 1fr;
  }
  @media (max-width: 1024px) {
    display: block;
  }
`;

export const GridLeft = styled.div`
  background-color: #7aa4a3;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding-right: 0.5rem;
  padding-top: 6.5rem;
  padding-bottom: 6rem;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const CenterList = styled.ul`
  margin-top: 1.05rem;
  color: #525252;
  font-family: 'LATOREGULAR';
  font-weight: 400;
  line-height: 37.5px;
  margin-left: -1.8rem;
  font-size: clamp(0.3rem, 1.1vw, 1.1rem);

  @media (max-width: 1500px) {
    font-size: clamp(0.3rem, 1vw, 1rem);
  }

  @media (max-width: 1024px) {
    margin-left: initial;
    font-size: 1rem;
  }
`;

export const EventBlock = styled.li`
  display: flex;
  align-items: flex-start;
  width: 44rem;
  margin-left: -10.3rem;

  @media (max-width: 1600px) {
    margin-top: 0rem;
    margin-bottom: 0rem;
  }

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: auto;
    margin-left: 0rem;
  }
`;

export const Date = styled.span`
  font-family: 'LATOBLACK';
  margin-right: 0.5rem;
  text-align: right;
  width: 10rem;
  @media (max-width: 1024px) {
    width: auto;
  }
`;

export const EventName = styled.span`
  font-family: 'LATOREGULAR';
  width: 34rem;
  padding-left: 1rem;
  position: relative;

  &::before {
    content: '—';
    font-family: 'LATOREGULAR';
    font-size: 1em;
    position: absolute;
    left: 0;
    @media (max-width: 1024px) {
      content: '';
    }
  }

  @media (max-width: 1024px) {
    width: auto;
    text-align: center;
    padding-left: 0;
  }
`;

export const GridTitle = styled.div`
  padding: 2rem 2rem;
  align-self: flex-start;
  padding-bottom: 6rem;
  position: relative;

  @media (max-width: 1024px) {
    padding-bottom: 1rem;
  }
`;

export const GridImage = styled.div`
  background-image: ${`url(${image})`};
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  @media (max-width: 1340px) {
    background: none;
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const ImageTitle = styled.span`
  font-size: 0.9rem;
  color: #525252;
  position: absolute;
  right: 14%;
  bottom: 22%;
  font-family: LATOREGULAR;
  font-weight: 600;
  font-style: italic;
  @media (max-width: 1340px) {
    display: none;
  }
`;

export const GridRight = styled.div``;

export const GalleryColumnTwo = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  justify-content: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const GalleryColumnFour = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr;
    flex-direction: column;
  }
`;

export const PhotoWithSign = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0rem 0;

  div {
    position: relative;
    &:hover {
      &::after {
        content: '';
        width: 100%;
        height: 100%;
        background-color: rgba(163, 192, 192, 0.4);
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  img {
    width: 100%;
    /* max-height: 405px; */
    height: 100%;
    object-fit: cover;
  }
`;

export const PhotoSign = styled.p`
  color: ${({color}) => color || '#525252'};
  font-family: Lato;
  font-size: 0.65rem;
  font-weight: 400;
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;
  text-align: center;
  margin-top: 1rem;
`;

export const TextSpaceMargin = styled.div`
  width: 80%;
  margin-right: auto;

  @media (max-width: 1365px) {
    width: 100%;
  }
`;

const animImg = keyframes`
  0%{
    transform: translateX(100%);
  }
  100%{
    transform: translateX(0);
  }
`;

export const ImageMove = styled.img`
  position: fixed;
  top: -20px;
  right: 0;
  max-width: 18rem;
  transform: translateX(100%);
  animation: ${animImg} 1.5s 1s forwards;

  @media (max-width: 1365px) {
    display: none;
  }
`;

export const SourceText = styled.p`
  color: #525252;
  font-family: 'LATOREGULAR';
  font-size: clamp(0.3rem, 0.8vw, 1.1rem);
  font-weight: 400;
  width: 60vw;
  position: absolute;
  bottom: 5%;
  right: 14%;
  text-align: right;
`;
